import { render, staticRenderFns } from "./plan-trabajo-editar.vue?vue&type=template&id=a1a2f1b0&"
import script from "./plan-trabajo-editar.vue?vue&type=script&lang=js&"
export * from "./plan-trabajo-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports